export default __webpack_public_path__ + "static/media/Logo.bec99656.png";